/**
 * Composable для работы с cookies выбранного пункта выдачи
 */

import { cookies } from 'globalState/elements/cookies.js';
import { DELIVERY_COOKIES, COOKIE_EXPIRY } from '../../constants/delivery.ts';
import type { IPickupPointState } from '../../types/delivery.ts';

export function usePickupPointCookie() {
    /**
     * Получить сохранённый пункт выдачи из cookies
     * @returns Данные пункта выдачи или null
     */
    const getPickupPoint = (): IPickupPointState | null => {
        const cookieValue = cookies.getCookie(DELIVERY_COOKIES.PICKUP_POINT);

        if (!cookieValue) {
            return null;
        }

        try {
            return JSON.parse(cookieValue) as IPickupPointState;
        } catch (error) {
            console.error(
                'Ошибка при парсинге selectedPickupPoint cookie:',
                error
            );
            return null;
        }
    };

    /**
     * Сохранить выбранный пункт выдачи в cookies
     * @param point - Данные пункта выдачи
     */
    const setPickupPoint = (point: IPickupPointState): void => {
        try {
            cookies.setCookie(
                DELIVERY_COOKIES.PICKUP_POINT,
                JSON.stringify(point),
                COOKIE_EXPIRY.PICKUP_POINT
            );
        } catch (error) {
            console.error(
                'Ошибка при сохранении selectedPickupPoint cookie:',
                error
            );
        }
    };

    /**
     * Очистить cookie выбранного пункта выдачи
     */
    const clearPickupPoint = (): void => {
        cookies.deleteCookie(DELIVERY_COOKIES.PICKUP_POINT);
    };

    /**
     * Проверить, совпадает ли сохранённый ПВЗ с указанным id
     * @param pointId - ID пункта выдачи
     * @returns true если сохранённый ПВЗ совпадает с указанным
     */
    const isSavedPoint = (pointId: string | number): boolean => {
        const saved = getPickupPoint();
        if (!saved) return false;

        return saved.id === pointId;
    };

    return {
        getPickupPoint,
        setPickupPoint,
        clearPickupPoint,
        isSavedPoint,
    };
}
